import './Footer.css';

export const Footer = () =>{
    return(
        <>
        <footer className="footer">
       <span id='text'>
        Copyright &#169; 2024 Aashish Lal.
        </span>
        </footer>
        </>
)};